<!-- eslint-disable max-len -->
<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="-8 -8 48 48" fill="none">
    <g clip-path="url(#clip0_7036_45512)">
      <path
        d="M19.1495 4.10705C19.4947 3.50918 20.2592 3.30434 20.8571 3.64952L27.3522 7.39952C28.6675 8.15891 29.1182 9.84078 28.3588 11.1561C27.5994 12.4714 25.9175 12.9221 24.6022 12.1627L18.1071 8.41266C17.5092 8.06748 17.3043 7.30299 17.6495 6.70513L19.1495 4.10705Z"
        :stroke="pathFill"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M21.1869 13.0777C21.7848 13.4229 21.9896 14.1874 21.6444 14.7853L14.1444 27.7757C13.247 29.3301 11.2593 29.8627 9.70484 28.9652L8.83882 28.4652C7.28437 27.5678 6.75177 25.5801 7.64924 24.0257L15.1492 11.0353C15.4944 10.4374 16.2589 10.2326 16.8568 10.5777L21.1869 13.0777Z"
        :stroke="pathFill"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <line
        x1="20.3299"
        y1="10.5623"
        x2="19.8299"
        y2="11.4283"
        :stroke="pathFill"
        stroke-width="2"
      />
      <path
        d="M29.4996 12.6805C29.8583 12.8876 30.317 12.7647 30.5241 12.406C30.7313 12.0473 30.6083 11.5886 30.2496 11.3815L29.4996 12.6805ZM27.7676 11.6805L29.4996 12.6805L30.2496 11.3815L28.5176 10.3815L27.7676 11.6805Z"
        :fill="pathFill"
      />
    </g>
    <defs>
      <clipPath id="clip0_7036_45512">
        <rect
          width="34"
          height="34"
          :fill="pathFill"
          transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 34 34)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    pathFill: {
      type: String,
      default: '#FFFFFF',
    },
  },
};
</script>
